{
  "errors": {
    "network": "Network error. Please check your connection and try again.",
    "unknown": "Something went wrong. Please try again.",
    "operationNotSupported": "Operation '{{operation}}' is not supported",
    "http": {
      "400": "Bad request",
      "401": "Unauthorized. Please log in again.",
      "403": "Access denied",
      "404": "Not found",
      "409": "This item already exists",
      "422": "Validation failed. Please check your inputs.",
      "500": "Server error. Please try again later.",
      "503": "Service temporarily unavailable"
    },
    "validation": {
      "required": "This field is required",
      "invalid": "Invalid value",
      "minLength": "Too short",
      "maxLength": "Too long",
      "duplicate": "Already exists",
      "email": "Invalid email address",
      "password": "Password does not meet requirements",
      "passwordsMismatch": "Passwords do not match",
      "failed": "Validation failed",
      "selectPerson": "Please select a person",
      "selectOrgFunction": "Please select a function",
      "selectSystem": "Please select a system",
      "selectExternalContact": "Please select an external contact",
      "fileRequired": "Please choose a file",
      "url": "Invalid URL"
    },
    "department": {
      "duplicateAbbreviation": "Department with abbreviation '{{abbreviation}}' already exists",
      "abbreviationAlreadyInUse": "Department abbreviation '{{abbreviation}}' is already in use",
      "abbreviationDuplicateInData": "Duplicate abbreviation '{{abbreviation}}' found in data",
      "nameAlreadyInUse": "Department name '{{name}}' is already in use",
      "nameDuplicateInData": "Duplicate name '{{name}}' found in data",
      "notFound": "Department not found",
      "parentNotFound": "Parent department not found",
      "selfParent": "A department cannot be its own parent",
      "circularDependency": "Cannot move a department under one of its own descendants",
      "hasSubdepartments": "Cannot delete department with subdepartments",
      "hasMembers": "Cannot delete department with people",
      "noManager": "The following departments have no manager assigned: {{departments}}. Please assign managers before creating processes.",
      "alreadyResolved": "This department already has a manager assigned"
    },
    "orgFunction": {
      "notFound": "Function not found",
      "mainRoleInvalidKind": "The main position must be a position-kind Function",
      "nameDuplicateInData": "Duplicate name '{{name}}' found in the data",
      "nameAmbiguous": "'{{name}}' is ambiguous – both a function and a team with this name exist",
      "alreadyExists": "'{{name}}' already exists and was skipped"
    },
    "common": {
      "invalidId": "Invalid ID provided"
    },
    "auth": {
      "invalidPassword": "Invalid email or password. Please try again.",
      "passwordUnchanged": "Your new password must be different from your current password.",
      "userNotFound": "Invalid email or password. Please try again.",
      "unauthorized": "Unauthorized. Please log in again.",
      "noMembership": "You don't have access to a workspace yet. Ask your administrator for an invitation.",
      "ssoRequired": "This workspace requires single sign-on. Continue with your email to sign in through your organization.",
      "notZitadelLinked": "Your account is not linked to the identity system yet. Sign in via single sign-on once, or contact your administrator.",
      "reauthRequired": "For security, please sign in again before changing your sign-in settings."
    },
    "sso": {
      "stateExpired": "Your sign-in session expired. Please try again.",
      "exchangeFailed": "Sign-in could not be completed. Please try again.",
      "transactionInvalid": "This sign-in link can only be completed in the browser where you started. Please sign in again.",
      "emailMismatch": "The signed-in account does not match the email you entered. Please try again.",
      "emailUnverified": "Your email address is not verified. Please verify it with your identity provider and try again."
    },
    "user": {
      "notFound": "User not found",
      "alreadyExists": "An account with this email ({{email}}) already exists.",
      "duplicateEmail": "User with email '{{email}}' already exists in this organization",
      "emailDuplicateInData": "Duplicate email '{{email}}' found in data",
      "invalidEmail": "Invalid email address",
      "inactive": "User account is inactive",
      "suspended": "Your account has been suspended. Please contact your administrator for assistance.",
      "alreadySuspended": "User account is already suspended",
      "alreadyActive": "User account is already active",
      "invalidStatus": "Invalid user status",
      "alreadyHasCredentials": "This person already has login credentials and can sign in directly — no activation link is needed.",
      "emailChangeNotAllowed": "The email address of this person cannot be changed because it is their sign-in identity. Contact support if it must change.",
      "externalMemberNoDepartment": "External people cannot be assigned to a department",
      "externalMemberNoTeam": "External people cannot be assigned to a function",
      "externalMemberRequiresRole": "External members must be given at least one user type",
      "userTypesTenantTypeMismatch": "These roles do not exist in this organization's type. Partner organizations hand out the partner roles, customer and demo organizations the customer roles.",
      "memberIsTeamLead": "Cannot reclassify to external: person is currently a function lead. Remove them as function lead first.",
      "emailNotFound": "No employee found with the email '{{email}}'"
    },
    "partner": {
      "tenantRequired": "This area is only available to partner organizations.",
      "adminRequired": "This action is reserved for partner admins.",
      "memberRequiresRole": "A member of a partner organization needs a partner role.",
      "memberMustBeInternal": "Members of a partner organization are the partner firm’s own internal staff.",
      "hubspotNotLinked": "This partner account is not linked to a HubSpot company yet. A Bliks administrator has to establish that link.",
      "salesNotActivated": "This member is not activated for sales, so the lead has no acquirer to be attributed to. A partner admin can activate them under User Management.",
      "salesAlreadyActivated": "This member is already activated for sales.",
      "memberNotActive": "This member has not accepted their invitation yet. Sales activation becomes available once they have signed in for the first time.",
      "contactAlreadyLinked": "This HubSpot contact is already linked to another member.",
      "memberNoEmail": "An email address is required to link a member to a HubSpot contact.",
      "contactNotAdoptable": "This HubSpot contact belongs to another partner company and cannot be added here.",
      "materialNotFound": "This material no longer exists.",
      "materialFileNotFound": "No file is available for this material.",
      "materialUploadInvalid": "The upload is invalid. Please upload the file again.",
      "newsNotFound": "This news entry no longer exists.",
      "newsImageInvalid": "The picture is invalid. Please upload it again."
    },
    "role": {
      "selfRemovalForbidden": "You cannot remove your own role — you would lose access to the page needed to undo it. Ask another admin to make this change.",
      "lastHolderForbidden": "This is the last active admin. The organization would be left with nobody able to manage its users."
    },
    "recording": {
      "invalidStatusForAction": "This action is not allowed in the recording's current state",
      "nameOrDescriptionRequired": "Both a name and a description are required to finalize the recording",
      "userNotRecordingStep": "You are not recording this step",
      "nudgeTargetNotActive": "This person cannot receive reminders because their account is not active",
      "decisionRuleNotFound": "Decision rule not found",
      "decisionHasNoRules": "Decision has no rules defined"
    },
    "process": {
      "notFound": "Process not found",
      "duplicateName": "Process with name '{{name}}' already exists",
      "invalidOperation": "This operation is not allowed in the current state"
    },
    "processEvent": {
      "notFound": "Event not found",
      "startRequired": "A process needs a start event — it cannot be removed or demoted"
    },
    "processChain": {
      "notFound": "Process chain not found",
      "circularDependency": "Cannot create circular dependency between process chains",
      "selfParent": "A process chain cannot be its own parent",
      "typeConflict": "A chain cannot contain both sub-chains and processes."
    },
    "processConnection": {
      "notFound": "Process connection not found"
    },
    "processStep": {
      "notFound": "Process step not found"
    },
    "processDraft": {
      "notFound": "No draft exists for this process.",
      "alreadyExists": "A draft already exists for this process.",
      "publishContentValidation": "Some steps are missing required content.",
      "publishGraphValidation": "Some steps are disconnected or orphaned.",
      "publishConflict": "The published process changed while you were editing.",
      "stepNotFound": "Draft step not found.",
      "edgeNotFound": "This connection no longer exists in the draft.",
      "deleteFailed": "Couldn't delete that — please try again.",
      "deletePartialFailure": "Some steps couldn't be deleted — please try again.",
      "deleteStaleSelection": "Those steps were already deleted.",
      "noteNotFound": "Note not found.",
      "historyNotFound": "No edit history exists for this draft.",
      "insertNotApplicable": "This step can no longer be inserted here.",
      "eventInputNotLinkable": "No event can be attached to this input.",
      "convertRequiresPreviousOutput": "An assignment needs at least one incoming result."
    },
    "organization": {
      "notFound": "Organization not found"
    },
    "approval": {
      "notFound": "Approval not found",
      "notPending": "This approval is no longer open",
      "notReviewer": "You are not a reviewer of this approval",
      "ownRequest": "Someone else approves your own request",
      "alreadyDecided": "You have already decided",
      "reasonRequired": "Please give a reason",
      "overrideNotAllowed": "The rule does not allow continuing without approval",
      "notRequester": "Only the requester can withdraw",
      "notAdmin": "Only workspace admins can do this"
    },
    "task": {
      "notFound": "Task not found",
      "alreadyCompleted": "Task is no longer open",
      "assigneeNotFound": "The person for this task was not found"
    },
    "assignment": {
      "notFound": "Assignment not found",
      "alreadyCompleted": "Assignment already completed",
      "alreadyAcceptedByTeammate": "This task has already been accepted by another holder of this function. Thank you for your commitment.",
      "taskNotDefined": "Assignment task not defined yet",
      "rulesNotDefined": "Assignment rules not defined yet",
      "outputNotDefined": "Assignment output is required",
      "alreadyFinished": "Assignment already finished",
      "reassigneeNotFound": "Reassignee not found",
      "notExternalContact": "This step is not assigned to an external contact",
      "recordingDelegateNotFound": "The selected person was not found"
    },
    "merge": {
      "targetNotFound": "The target step recording was not found.",
      "targetNotCompleted": "The target step recording is not yet completed.",
      "targetWrongProcess": "The target step recording belongs to a different process.",
      "userNotRelated": "You do not have a relationship to this step recording.",
      "sameNode": "A step cannot be merged into itself."
    },
    "system": {
      "notFound": "System not found",
      "nameDuplicateInData": "Duplicate system name '{{name}}' found in the data",
      "alreadyExists": "System '{{name}}' already exists and was skipped"
    },
    "artifact": {
      "notFound": "Document not found"
    },
    "externalContact": {
      "notFound": "External contact not found"
    },
    "tenant": {
      "notFound": "Tenant not found",
      "expired": "Your organization's access has expired. Please contact your administrator.",
      "cloneFailed": "Failed to clone tenant. The incomplete copy may be left over — it can be discarded from the tenant list.",
      "cloneDiscardRefused": "Discarding the copy was refused by a safety check — for example because the clone finished after all and the tenant is no longer this job’s to remove, or because its worker is still running. Nothing was deleted.",
      "cloneInProgress": "A clone involving this tenant is still running. Wait for it to finish and try again. A running clone cannot be cancelled.",
      "slugAlreadyInUse": "This slug is already in use by another tenant. Please choose a different one.",
      "typeChangeStrandsMembers": "This organization’s type cannot change while {{count}} members hold roles of its current type. Adjust those roles first, or empty the organization.",
      "hubspotCompanyAlreadyLinked": "This HubSpot company is already linked to another tenant."
    },
    "appConfig": {
      "notConfigurable": "This app has no configurable settings.",
      "invalid": "The configuration does not match what the app expects."
    },
    "seatLimit": {
      "systemAdminsReached": "The system admin seat limit is reached ({{current}} of {{limit}} seats in use). Suspend or delete a system admin or have the limit raised.",
      "orgManagersReached": "The organization manager seat limit is reached ({{current}} of {{limit}} seats in use). Suspend or delete an organization manager or have the limit raised.",
      "membersReached": "The basic user seat limit is reached ({{current}} of {{limit}} seats in use). Suspend or delete a basic user or have the limit raised.",
      "appSeatsReached": "This app has {{limit}} seats, but {{requested}} users were assigned. Assign fewer users or have the limit raised.",
      "appSeatOrgManagerNotSeatable": "Organization managers already reach every app and cannot take a seat. Remove them from the assignment and save again."
    },
    "seatOverrun": "Your organization has more users than seats. An organization manager or system administrator must suspend or delete a user before changes can be saved.",
    "initialSetup": {
      "alreadyCompleted": "Initial setup has already been completed and cannot be re-run.",
      "prerequisitesMissing": "Please set up departments and employees first",
      "notCompleted": "Your organization's initial setup is not finished yet. Changes are only possible afterwards.",
      "updateNotAllowed": "This entry can no longer be edited here. Please reload the page and try again.",
      "removalBlocked": "This entry cannot be deleted because other entries reference it.",
      "incomplete": "The initial setup is incomplete. Please fix the remaining gaps before finishing."
    },
    "dataSync": {
      "syncRunNotFound": "This sync no longer exists.",
      "syncRunInProgress": "A sync is already running for this organization. Try again once it has finished.",
      "syncRunStale": "This sync stopped before it finished. Start a new sync.",
      "syncRunNotInReview": "This sync can no longer be applied. Start a new sync.",
      "selectionInvalid": "Some selected changes cannot be applied as selected. Check the selection and try again.",
      "excelInvalidIds": "The file contains invalid IDs ({{rows}}). Keep the IDs from the downloaded file unchanged.",
      "excelDuplicateEmails": "Several rows share an email address ({{rows}}). Each person needs their own email address.",
      "excelDuplicateIds": "Several rows carry the same ID ({{rows}}). Download the current file and enter your changes there.",
      "excelUnknownIds": "The file contains IDs that do not exist in Bliks ({{rows}}). Download the current file and enter your changes there.",
      "excelMismatchedIds": "These rows carry the name of another entry ({{rows}}). Download the current file and enter your changes there. To give an entry the name of one this file deletes, upload the deletion first.",
      "excelDuplicateNames": "Several new rows share a name ({{rows}}). Give each new entry its own name.",
      "excelNameMatchesSeveral": "These rows without an ID carry a name that several existing entries have ({{rows}}). Enter the ID of the entry each row means, as the downloaded file has it.",
      "excelEmptyReferencedSheet": "The {{sheet}} sheet has no rows, but other rows name entries of it. Add those entries to the {{sheet}} sheet, or clear the cells that name them.",
      "excelAmbiguousNames": "Several rows share a name that another cell refers to ({{rows}}). Make the names unique.",
      "excelUnresolvedReferences": "These rows name a department or position the file does not contain ({{rows}}). Add it to the {{departmentsSheet}} or {{rolesSheet}} sheet, or correct the name.",
      "excelParentCycle": "These departments are each other's parents ({{rows}}). Correct the parent departments.",
      "excelUnknownEmails": "These rows name an email address that belongs to nobody ({{rows}}). Add the person to the {{peopleSheet}} sheet, or correct the address.",
      "excelUnlistedLeads": "These rows name a person the file removes ({{rows}}). Add the person to the {{peopleSheet}} sheet, or name another person.",
      "excelNoPeople": "The {{sheet}} sheet contains no people.",
      "personioNotLinked": "Personio is not linked.",
      "personioCredentialsRejected": "Personio rejected the credentials. Check the client ID and the client secret.",
      "personioReadFailed": "Personio could not be read completely. Nothing was changed. Try again later.",
      "personioCredentialsUnreadable": "The stored Personio credentials can no longer be read. Please link Personio again."
    },
    "capacity": {
      "manualNotApplicable": "This step is assigned to a system or an external contact, so it collects no capacity."
    },
    "survey": {
      "notFound": "Survey not found",
      "notApplicable": "This survey has no question for you",
      "variantCheckNotApplicable": "This question is not open to you",
      "variantDescriptionRequired": "Please describe what you do differently",
      "variantVerdictRequired": "Please answer whether you perform this step the same way",
      "variantAlreadyAnswered": "This survey has already been answered. Please reload the page.",
      "alreadyDismissed": "This survey was already declined"
    },
    "entitySuggestion": {
      "notFound": "Entity suggestion not found",
      "invalidTransition": "This suggestion cannot transition to that state",
      "missingAdminField": "An administrator-only field is required"
    },
    "insufficientPermissions": "Insufficient permissions",
    "totp": {
      "unavailable": "Two-factor authentication is not available for your account.",
      "invalidCode": "The code is invalid. Please try again.",
      "alreadyConfigured": "Two-factor authentication is already set up. Remove it first to set it up again.",
      "registrationNotFound": "No pending 2FA setup was found. Please start the setup again."
    },
    "passkeys": {
      "unavailable": "Passkeys are not available for your account.",
      "lastAuthMethod": "This passkey is your last sign-in method and cannot be removed. Set up a password or another passkey first."
    },
    "homeOrgMove": {
      "noIdentity": "This user has no sign-in identity to move.",
      "targetNotSsoEnabled": "The selected organization is not SSO-enabled.",
      "noMembershipInTarget": "This user is not an active member of the selected organization.",
      "staffRefused": "Staff accounts cannot be moved to another home organization.",
      "identityDisabled": "This user’s sign-in identity is disabled and cannot be moved.",
      "conflict": "The user’s sign-in identity changed while the move was running. Please reload and try again.",
      "emailConflict": "A sign-in account with the email {{email}} already belongs to a different person.",
      "deadEmailSyncItem": "This user has a stalled email-change sync item. Revive or delete it in the sync queue before moving the home organization."
    },
    "signInReset": {
      "notPermitted": "Only a system admin of this person’s home organization can reset their sign-in.",
      "self": "You cannot reset your own sign-in.",
      "userNotActive": "Only active members can have their sign-in reset. For a pending invitation, resend the invitation instead.",
      "noHomeOrg": "This person’s home organization is unknown, so their sign-in cannot be reset here.",
      "homeOrgDeleted": "This person’s home organization was deleted. Assign a new home organization before resetting their sign-in.",
      "ssoEnforced": "This person signs in through their organization’s single sign-on, so their sign-in is managed there.",
      "conflict": "This person’s sign-in changed while the reset was running. Please reload and try again.",
      "identityDisabled": "This person’s sign-in is disabled, so it cannot be reset. Restore their access first.",
      "emailChangeUnsettled": "An email change for this address has not reached the sign-in account yet, so the sign-in cannot be reset now. Please try again in a few minutes; if this persists, contact support."
    },
    "stepTemplate": {
      "notFound": "Step template not found",
      "invalidSelection": "The selection contains elements that do not belong to this draft",
      "corrupt": "The step template is corrupted and cannot be inserted"
    },
    "app": {
      "notFoundInRegistry": "This app is not available.",
      "notAvailableForTenant": "This app is not available for your workspace. Contact your administrator.",
      "notUnlocked": "This app is not unlocked for this tenant.",
      "notInstalled": "This app is not installed for your workspace.",
      "notActive": "This app is not active for your workspace.",
      "fileNotFound": "File not found",
      "fileTypeUnsupported": "Unsupported file type: {{mimeType}}",
      "fileTooLarge": "The file is larger than the {{maxSizeBytes}} byte limit.",
      "fileExpired": "This file is no longer available — its retention window has passed."
    },
    "appChat": {
      "sessionNotFound": "This chat session no longer exists."
    },
    "omniscient": {
      "exportNotFound": "Export not found"
    },
    "transcription": {
      "audioFormatUnsupported": "Unsupported audio format: {{mimeType}}"
    },
    "chat": {
      "messageNotFound": "This message no longer exists."
    },
    "account": {
      "parentCycle": "This account cannot sit under itself.",
      "parentTooDeep": "The group nests too deeply.",
      "companyAlreadyAssigned": "This HubSpot company is already assigned to another account.",
      "partnerCompanyLocked": "This account runs a partner workspace ({{tenantName}}). Only someone who manages workspaces may change its HubSpot company.",
      "notFound": "Account not found."
    },
    "hubspot": {
      "companyNotFound": "No HubSpot company with this id."
    },
    "superAdmin": {
      "lastAdmin": "No one would be left who can sign in as platform administrator — and only they can assign roles."
    }
  }
}
